/**
 * Set Address
 * @param {Object} payload - Address Object.
 */
export const set = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit('SET_STREET', payload.street)
    commit('SET_POSTALCODE', payload.postalCode)
    commit('SET_TOWN', payload.town)
    commit('SET_CITY', payload.city)
    commit('SET_COUNTRY', payload.country)
    resolve()
  })
}
